var render, staticRenderFns
import script from "./Top10AgenciesByRevenueCY.vue?vue&type=script&lang=js&"
export * from "./Top10AgenciesByRevenueCY.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6cbe34",
  null
  
)

export default component.exports